import { inject, Injectable } from '@angular/core';
import { ApiService } from 'src/app/abstract-classes/api.service/api.service';
import { GemstoneSetting } from 'src/app/interfaces/gemstone-setting';
import { StoneSettingsProviderService } from 'src/app/providers/stone-settings/stone-settings.provider.service';

@Injectable({
  providedIn: 'root'
})
export class StoneSettingsService extends ApiService<GemstoneSetting, StoneSettingsProviderService> {
  private providerService = inject(StoneSettingsProviderService);
  protected override get provider(): StoneSettingsProviderService {
    return this.providerService;
  }
}
